/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';

const SidebarLink = ({
  title, icon, newLink, route, onClick, linkColor, linkReverseColor,
}) => {
  const [hover, setHover] = useState(false);

  const toggleHover = (opt) => {
    setHover(opt);
  };

  return (
    <NavLink
      to={route}
      onClick={onClick}
      activeClassName="sidebar__link-active"
    >
      <div
        onMouseEnter={() => toggleHover(true)}
        onMouseLeave={() => toggleHover(false)}
        style={{
          backgroundColor: hover ? linkColor : null,
          transition: 'background-color 0.3s ease',
        }}
        className="sidebar__link"
      >
        <div style={{ color: hover ? linkReverseColor : 'black' }}>
          {icon}
        </div>
        <p className="sidebar__link-title" style={{ margin: 0, color: hover ? linkReverseColor : null }}>
          {title}
          {newLink && <Badge className="sidebar__link-badge"><span>New</span></Badge>}
        </p>
      </div>
    </NavLink>
  );
};

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.any.isRequired,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
  linkColor: PropTypes.string.isRequired,
  linkReverseColor: PropTypes.string.isRequired,
};

SidebarLink.defaultProps = {
  newLink: false,
  route: '/',
  onClick: () => {},
};

export default SidebarLink;
